/*
  Drives the promo countdown strip.

  Each tick recomputes the remaining time from an absolute target rather than
  decrementing a counter, so the clock cannot drift: a throttled background tab,
  a sleeping laptop, or a dropped interval all resolve themselves on the next
  tick instead of accumulating error.

  Rolling over is implicit -- once the target passes, the next target is a day
  later, so the bar restarts on its own with no special case.
*/
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // The next time the clock strikes `hour` in the viewer's own timezone.
  function nextTarget(hour) {
    const now = new Date();
    const target = new Date(now);
    target.setHours(hour, 0, 0, 0);
    if (target <= now) target.setDate(target.getDate() + 1);
    return target;
  }

  function init(bar) {
    if (bar.dataset.cdbBound === 'true') return;
    bar.dataset.cdbBound = 'true';

    const hours = bar.querySelector('[data-countdown-hours]');
    const minutes = bar.querySelector('[data-countdown-minutes]');
    const seconds = bar.querySelector('[data-countdown-seconds]');
    if (!hours || !minutes || !seconds) return;

    let resetHour = parseInt(bar.dataset.resetHour, 10);
    if (!Number.isInteger(resetHour) || resetHour < 0 || resetHour > 23) resetHour = 0;

    let target = nextTarget(resetHour);
    let timer = null;

    const render = () => {
      let remaining = target - new Date();
      if (remaining <= 0) {
        target = nextTarget(resetHour);
        remaining = target - new Date();
      }

      const total = Math.floor(remaining / 1000);
      hours.textContent = pad(Math.floor(total / 3600));
      minutes.textContent = pad(Math.floor((total % 3600) / 60));
      seconds.textContent = pad(total % 60);
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      render();
      timer = setInterval(render, 1000);
    };

    // No point ticking a clock nobody is looking at; render() on the way back
    // catches it up in one step.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function bindAll() {
    document.querySelectorAll('.countdown-bar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
